import { styled } from "@mui/material";

export const Container = styled("div")(() => ({
  minWidth: "324px",
  maxWidth: "400px",
  width: "100%",
  backgroundColor: "var(--color-surface)",
  borderRadius: "8px",
  boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
  overflow: "hidden",
  fontFamily: "var(--xvia-font-family)",
}));

export const Header = styled("div")(() => ({
  backgroundColor: "var(--color-primary)",
  color: "var(--color-surface)",
  padding: "16px",
  position: "relative",
  fontFamily: "var(--xvia-font-family)",
}));

export const CloseButton = styled("button")(() => ({
  position: "absolute",
  top: "16px",
  right: "16px",
  color: "var(--color-surface)",
  transition: "color 0.2s",
  background: "none",
  border: "none",
  cursor: "pointer",

  "&:hover": {
    color: "var(--color-grey-40)",
  },
}));

export const Avatar = styled("div")(() => ({
  width: "68px",
  height: "68px",
  borderRadius: "50%",
  overflow: "hidden",
  backgroundColor: "var(--color-grey-30)",
  flexShrink: 0,
}));

export const AvatarImage = styled("img")(() => ({
  width: "100%",
  height: "100%",
  objectFit: "cover",
}));

export const AvatarFallback = styled("div")(() => ({
  width: "100%",
  height: "100%",
  backgroundColor: "var(--color-grey-50)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontFamily: "var(--xvia-font-family)",
}));

export const UserInfo = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "12px",
}));

export const UserDetails = styled("div")(() => ({
  flex: 1,
  minWidth: 0,
}));

export const UserName = styled("h3")(() => ({
  fontWeight: 600,
  fontSize: "var(--font-subtitle-3)",
  color: "var(--color-surface)",
  margin: 0,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  fontFamily: "var(--xvia-font-family)",
}));

export const UserLevel = styled("p")(() => ({
  fontSize: "var(--font-body-2)",
  lineHeight: "var(--line-height-body-2)",
  letterSpacing: "var(--letter-spacing-body-2)",
  color: "var(--color-body-2)",
  margin: 0,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  fontFamily: "var(--xvia-font-family)",
}));

export const Content = styled("div")(() => ({
  padding: "16px",
  display: "flex",
  flexDirection: "column",
  fontFamily: "var(--xvia-font-family)",
}));

export const Section = styled("div")(() => ({
  padding: "16px",
  borderBottom: "1px solid var(--color-grey-20)",
}));

export const SectionLabel = styled("label")(() => ({
  display: "block",
  fontSize: "var(--font-button)",
  lineHeight: "var(--line-height-button)",
  letterSpacing: "var(--letter-spacing-button)",
  fontWeight: 500,
  color: "var(--color-grey-80)",
  marginBottom: "8px",
  fontFamily: "var(--xvia-font-family)",
}));

export const PortalButton = styled("button")(() => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "12px",
  border: "1px solid var(--color-surface-border)",
  borderRadius: "6px",
  backgroundColor: "var(--color-surface)",
  cursor: "pointer",
  transition: "background-color 0.2s",
  fontFamily: "var(--xvia-font-family)",

  "&:hover": {
    backgroundColor: "var(--color-grey-30)",
  },
}));

export const PortalButtonContent = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
}));

export const PortalButtonText = styled("span")(() => ({
  color: "var(--color-grey-90)",
  fontSize: "var(--font-subtitle-3)",
  fontFamily: "var(--xvia-font-family)",
}));

export const ExpandableContent = styled("div", {
  shouldForwardProp: (prop) => prop !== "isExpanded",
})<{ isExpanded: boolean }>(({ isExpanded }) => ({
  overflow: "hidden",
  maxHeight: isExpanded ? "300px" : "0",
  transition: "max-height 0.3s ease-in-out",
  borderLeft: "1px solid var(--color-surface-border)",
  borderRight: "1px solid var(--color-surface-border)",
  borderBottom: isExpanded ? "1px solid var(--color-surface-border)" : "none",
  borderRadius: "0 0 6px 6px",
  backgroundColor: "var(--color-surface)",
}));

export const ExpandableNavList = styled("div")(() => ({
  padding: "8px 0",
}));

export const ExpandableNavItem = styled("a")(() => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  gap: "12px",
  padding: "12px 16px",
  background: "none",
  border: "none",
  cursor: "pointer",
  transition: "background-color 0.2s",
  textAlign: "left",
  fontFamily: "var(--xvia-font-family)",

  "&:hover": {
    backgroundColor: "var(--color-grey-30)",
  },
}));

export const NavItemIcon = styled("span")(() => ({
  color: "var(--color-grey-70)",
  flexShrink: 0,
}));

export const NavItemText = styled("span")(() => ({
  color: "var(--color-grey-90)",
  fontSize: "var(--font-subtitle-3)",
  lineHeight: "var(--line-height-body-1)",
  fontFamily: "var(--xvia-font-family)",
}));

export const LoginHeader = styled("div")(() => ({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  gap: "8px",
  justifyContent: "flex-start",
}));

export const LoginTitle = styled("h3")(() => ({
  fontWeight: 600,
  fontSize: "var(--font-subtitle-1)",
  margin: 0,
  color: "var(--color-surface)",
}));
